import './css/styles.scss';

function kontaktCtaInit() {}

kontaktCtaInit();
